import { useMemo, useState } from "react";
import SectionTitle from "./SectionTitle";
import { issueCategories, issueList } from "@/mocks/home";

export default function IssuesFilter() {
  const [active, setActive] = useState("all");
  const [openId, setOpenId] = useState<string | null>(null);

  const filtered = useMemo(
    () => (active === "all" ? issueList : issueList.filter((i) => i.category === active)),
    [active],
  );

  const toggle = (id: string) => setOpenId((prev) => (prev === id ? null : id));

  return (
    <section className="bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <SectionTitle
          eyebrow="对症下药"
          title="按症状筛选，找到对应解法"
          desc="选择你在播放时遇到的情况，下面会只保留相关问题；点击任意条目可以展开查看原因与处理办法。"
        />

        <div className="flex flex-wrap gap-2 mb-8">
          {issueCategories.map((cat) => {
            const isActive = active === cat.id;
            return (
              <button
                key={cat.id}
                type="button"
                onClick={() => setActive(cat.id)}
                aria-pressed={isActive}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap border ${
                  isActive
                    ? "bg-primary-500 text-background-50 border-primary-500"
                    : "bg-background-50 text-foreground-700 border-background-300 hover:bg-background-100"
                }`}
              >
                {cat.label}
              </button>
            );
          })}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {filtered.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className="rounded-lg border border-background-200 bg-background-50 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => toggle(item.id)}
                  aria-expanded={isOpen}
                  className="w-full flex items-start gap-4 text-left px-5 py-4 hover:bg-background-100 transition-colors"
                >
                  <span className="mt-0.5 w-8 h-8 shrink-0 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
                    <i className="ri-question-line text-lg" aria-hidden="true"></i>
                  </span>
                  <span className="flex-1 min-w-0">
                    <span className="block text-sm md:text-base font-semibold text-foreground-950">
                      {item.title}
                    </span>
                    <span className="mt-1 block text-xs text-foreground-500">{item.symptom}</span>
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-xl text-foreground-500 transition-transform ${
                      isOpen ? "rotate-180" : ""
                    }`}
                    aria-hidden="true"
                  ></i>
                </button>

                {isOpen && (
                  <div className="px-5 pb-5 pl-[68px]">
                    <p className="text-sm text-foreground-700 leading-relaxed">
                      <span className="font-medium text-foreground-900">可能原因：</span>
                      {item.cause}
                    </p>
                    <p className="mt-2 text-sm text-foreground-700 leading-relaxed">
                      <span className="font-medium text-primary-700">处理办法：</span>
                      {item.fix}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {filtered.length === 0 && (
          <p className="text-sm text-foreground-600 py-8 text-center">该分类下暂无条目，换个分类试试。</p>
        )}
      </div>
    </section>
  );
}